import Swal from 'sweetalert2'
import { deleteByIdArticulos, recoverArticulosDeleted } from '../../../Services/articuloService'

const useDelete = (setIsLoad) => {

  const deleteArticuloSubmit = (articulo) => {
    Swal.fire({
      title: 'Estas seguro de eliminar?',
      text: 'Se eliminara un articulo!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, Eliminar!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        // consulta a la api para eliminar
        deleteByIdArticulos(articulo.id)
          .then((res) => {
            Swal.fire(
              'Eliminado!',
              'El articulo fue eliminado.',
              'success'
            )
            setIsLoad(true)
          })
          .catch((error) => {
            Swal.fire({
              type: 'error',
              title: 'Error',
              text: 'Hubo un error vuelve a intentar!',
            })
            console.log(error.response)
          })
      }
    })
  }

  const recoverArticuloSubmit = (articulo) => {
    Swal.fire({
      title: 'Estas seguro de recuperarlo?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, Recuperar!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        // consulta a la api para eliminar
        recoverArticulosDeleted(articulo.id)
          .then((res) => {
            Swal.fire(
              'Recuperado!',
              'El articulo fue recuperado.',
              'success'
            )
            setIsLoad(true)
          })
          .catch((error) => {
            Swal.fire({
              type: 'error',
              title: 'Error',
              text: 'Hubo un error vuelve a intentar!',
            })
            console.log(error.response)
          })
      }
    })
  }
  return {
    deleteArticuloSubmit,
    recoverArticuloSubmit
  }
}

export default useDelete